import script from "./page-view.vue?vue&type=script&setup=true&lang=js"
export * from "./page-view.vue?vue&type=script&setup=true&lang=js"

import "./page-view.vue?vue&type=style&index=0&id=7f71ca29&lang=scss"

const __exports__ = script;

export default __exports__